import type { OcsPatchEntryInput } from 'owa-graph-schema';
import { lazyWriteOcsSettings } from 'owa-ocs-service-gql';
import { getAccountScopeUserSettings } from 'owa-session-store';
import type { MailboxInfo } from 'owa-client-types';
import { logUsage } from 'owa-analytics';
import type { ConditionalFormattingScenario } from '../store/schema/ConditionalFormattingScenarioType';
import { getConditionalFormattingSettingName } from '../utils/getConditionalFormattingScenarioSettingUtils';

export default function saveConditionalFormattingRulesService(
    mailboxInfo: MailboxInfo,
    rules: string,
    scenario: ConditionalFormattingScenario
): void {
    const ocsConditionalFormattingPatch: OcsPatchEntryInput = {
        name: getConditionalFormattingSettingName(scenario),
        value: rules,
        type: 'JSON',
        scope: getAccountScopeUserSettings(mailboxInfo).SessionSettings?.UserEmailAddress || '',
        itemClass: 'RoamingSetting',
    };
    lazyWriteOcsSettings
        .importAndExecute(
            mailboxInfo,
            'ACCOUNT',
            [ocsConditionalFormattingPatch],
            'setMailConditionalFormatting' /* actionName */
        )
        .catch(err => logErrorOnSave(mailboxInfo, err));
}

function logErrorOnSave(mailboxInfo: MailboxInfo, err: Error) {
    logUsage('TnS_ConditionalFormatting_ErrorSave', mailboxInfo, {
        message: err.message,
    });
}
